import { cloneDeep, isEqual } from 'lodash';
import getNewSubShiftTime from './getNewSubShiftTime';

const MAX_PREGNANCY_HOUR = 18;
const MIN_PREGNANCY_HOUR = 8;

const onDropCalendar = ({ source, location, updateState, showWeek, accountIndex, accounts, onOpenToast, generateResultData, t }) => {
  const target = location.current.dropTargets[0];

  if (!target) return;

  const currentAccount = accounts[accountIndex];
  const { datas } = currentAccount;

  const weekIndex = datas?.findIndex((data) => data.week === showWeek);
  const schedules = datas[weekIndex].schedules;

  const targetLocation = target.data.location;
  const sourceSchedule = schedules.find((schedule) => isEqual(schedule.location, source.data.host.location) && isEqual(schedule.name, source.data.host.name));

  const targetLocationSchedule = schedules.filter((schedule) => isEqual(schedule.location, targetLocation));

  const isTheSameHost = targetLocationSchedule.some((schedule) => schedule?.userId === sourceSchedule?.userId);

  const isDoubleSchedule = accounts
    ?.find((_, index) => index !== accountIndex)
    ?.datas?.find((data) => data.week === showWeek)
    ?.schedules?.find((schedule) => schedule.userId === sourceSchedule.userId && isEqual(schedule.location, targetLocation));

  if (isDoubleSchedule || isTheSameHost) {
    onOpenToast({
      status: 'error',
      description: t('hostAlreadyHasSchedule', { hostName: sourceSchedule?.name }),
      duration: 3,
      alwaysShow: false,
    });
    return;
  }

  if (targetLocationSchedule.length === 3) {
    onOpenToast({
      status: 'error',
      description: 'Jadwal sudah maximum!',
      duration: 3,
      alwaysShow: false,
    });

    return;
  }

  if (sourceSchedule.isPregnancy && (targetLocation[1] >= MAX_PREGNANCY_HOUR || targetLocation[1] < MIN_PREGNANCY_HOUR)) {
    onOpenToast({
      status: 'error',
      description: t('pregnantBreastfeedingTimeRestriction'),
      duration: 3,
      alwaysShow: false,
    });
    return;
  }

  const theRestOfSchedule = schedules.filter(
    (schedule) => !isEqual(schedule.location, source.data.host.location) || !isEqual(schedule.name, source.data.host.name)
  );

  const { newSubShiftStartTime, newSubShiftEndTime } = getNewSubShiftTime(generateResultData?.metadata, targetLocation, cloneDeep(sourceSchedule));

  datas[weekIndex] = {
    ...datas[weekIndex],
    schedules: [
      {
        ...sourceSchedule,
        location: targetLocation,
        subShiftStartTime: newSubShiftStartTime,
        subShiftEndTime: newSubShiftEndTime,
      },
      ...theRestOfSchedule,
    ],
  };

  accounts[accountIndex] = {
    ...accounts[accountIndex],
    datas,
  };

  updateState({ accounts });
};

export default onDropCalendar;
